import { collection, addDoc, serverTimestamp } from "firebase/firestore"
import { db } from "./firebase"

// ── Validación de requisitos mínimos para guardar ──────────────────────
export function validarCotizacion(ctx) {
  const err = []
  if (!ctx?.vendedor?.uid)                  err.push("No hay usuario autenticado.")
  if (!ctx?.viaje?.destinos?.[0]?.nombre)  err.push("Falta el destino 1.")
  if (!ctx?.viaje?.fechaSalida)            err.push("Falta la fecha de salida.")
  if (!ctx?.viaje?.fechaRegreso)           err.push("Falta la fecha de regreso.")
  if (!(ctx?.viaje?.pasajeros?.total > 0)) err.push("La cantidad de pasajeros debe ser mayor a 0.")
  if (!ctx?.vuelo?.aerolinea)              err.push("Falta la aerolínea.")
  if (!(ctx?.vuelo?.precioTotal > 0))      err.push("El precio del vuelo debe ser mayor a 0.")

  for (const d of (ctx?.viaje?.destinos || [])) {
    if (!d.hotel?.nombre)              err.push(`Falta el nombre del hotel en ${d.nombre}.`)
    else if (!(d.hotel?.precioTotal > 0)) err.push(`El precio del hotel en ${d.nombre} debe ser mayor a 0.`)
  }

  for (const t of (ctx?.traslados || [])) {
    if (t.noConfigurado && t.montoManual === null)
      err.push(`Traslado sin tarifa: ${t.origen} → ${t.destino}. Ingresá el monto manualmente.`)
  }

  if (!(ctx?.costos?.precioFinal > 0)) err.push("El precio final debe ser mayor a 0.")

  return err
}

// ── Guardado en Firestore ──────────────────────────────────────────────
export async function guardarCotizacion(docData) {
  const ref = await addDoc(collection(db, "cotizaciones"), {
    ...docData,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  })
  return ref.id
}